<div class="flex-row padding-top-8 padding-bottom-8">
  <mat-checkbox
    [disabled]="state!=='NEW'"
    *ngIf="selector"
    class="margin-8"
    matRipple
    role="button"
    [checked]="selected"
    (change)="onChange($event)">
  </mat-checkbox>
  <div class="space-width actionable {{selector && state !=='NEW' ? 'disabled': ''}}">
    <div class="header padding-bottom-8">
      <div class="column-full-width" (click)="linkClicked()">
        <div class="name">{{orderno || 'Número de orden: Pendiente de asignar'}}</div>
        <div class="margin-right-16 basic-data">
          <div class="padding-bottom-8 padding-top-8">
            <span class="project">{{project}}</span>
          </div>
        </div>
        <div>
          <humanize-state [state]="state" [parent]="parent"></humanize-state>
        </div>
        <div class="icon-text no-sync" *ngIf="computePendingSync">
          <mat-icon>cloud_off</mat-icon> <span> Pendiente de sincronizar </span>
        </div>
      </div>
      <div class="actions {{selector ? 'invisible': ''}}" *ngIf="actions">
        <contextual-action [actions]="actions" [collapseAll]="true" (actionEvent)="onClickActionEvent($event)"></contextual-action>
      </div>
    </div>
    <div class="container" (click)="linkClicked()">
      <div class="data">
        <div class="margin-right-16 basic-data">
          <div class="icon-text">
            <mat-icon>account_circle</mat-icon>
            <span *ngIf="technician">Técnico asignado:  {{technician.name}} {{technician.surname}} </span>
            <i class="error" *ngIf="!technician">Sin asignar </i>
          </div>
          <div class="icon-text" *ngFor="let participant of participants">
            <mat-icon>account_circle</mat-icon><span>Responsable de seguridad: {{participant.name}} {{participant.surname}} </span>
          </div>
          <div class="icon-text" *ngIf="type">
            <mat-icon>build</mat-icon> <span> {{type.description}} </span>
          </div>
          <div class="icon-text" *ngIf="painType">
            <mat-icon>healing</mat-icon> <span> {{painType.description}} </span>
          </div>
          <div *ngIf="painDescription">
            <div class="icon-text">
              <mat-icon>description</mat-icon> <span> Observaciones del daño:</span>
            </div>
            <div class="subtitle-description">
              <p> {{painDescription}} </p>
            </div>
          </div>
          <div class="icon-text" *ngIf="estimatedResolutionDate && !closed">
            <mat-icon>calendar_today</mat-icon> <span> Fecha estimada: {{estimatedResolutionDate | formatDate}} </span>
          </div>
          <div class="icon-text" *ngIf="repairmentDate">
            <mat-icon>calendar_today</mat-icon> <span> Fecha de resolución: {{repairmentDate | formatDate}} </span>
          </div>
          <div class="icon-text">
            <mat-icon>wb_incandescent</mat-icon>
            <span class="name" *ngIf="luminaryNumber">{{luminaryNumber}}</span>
            <span *ngIf="newLuminaryNumber"> ({{newLuminaryNumber}})</span>
            <i class="name error" *ngIf="!luminaryNumber">Luminaria sin identificar</i>
          </div>
          <div class="icon-text" *ngIf="luminaryOfTemporalUse">
            <mat-icon>timelapse</mat-icon> Luminaria de uso temporal
          </div>
          <div *ngIf="address && !closed">
            <div class="subtitle ubication icon-text">
              <mat-icon>room</mat-icon> <span> {{address}} </span>
            </div>
          </div>
          <div class="subtitle icon-text" *ngIf="neighborhood && !closed">
            <span>Barrio: {{neighborhood}} </span>
          </div>
          <div class="subtitle icon-text" *ngIf="referencePoint && !closed">
            <span>Punto de referencia: {{referencePoint}}</span>
          </div>
          <div class="padding-top-8 padding-bottom-8" *ngIf="pqr">
            <span>Datos de PQR</span>
          </div>
          <div class="icon-text" *ngIf="petitioner">
            <mat-icon>face</mat-icon> <span>Contacto: {{this.petitioner.name}} </span>
          </div>
          <div class="subtitle icon-text" *ngIf="petitioner">
            <span> {{contactMedia}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <div class="tagged-data">
    <tag-automatic-color icon="memory" [text]="technology" matRipple *ngIf="technology"></tag-automatic-color>
    <tag-automatic-color icon="offline_bolt" [text]="power" matRipple *ngIf="power"></tag-automatic-color>
    <mat-icon *ngIf="newTechnology && newPower">chevron_right</mat-icon>
    <tag-automatic-color icon="memory" [text]="newTechnology" class="actionable" matRipple *ngIf="newTechnology"></tag-automatic-color>
    <tag-automatic-color icon="offline_bolt" [text]="newPower" class="actionable" matRipple *ngIf="newPower"></tag-automatic-color>
  </div>
  <div class="tagged-data" *ngIf="materials">
    <tag-automatic-color [keyColor]="technology+'_'+power" *ngFor="let material of materials" [text]="material | humanizeDescriptionMaterial"></tag-automatic-color>
  </div>
</div>
